<template>
  <transition name="bcc-notification-fade" @after-leave="handleAfterLeave">
    <div
      :class="[
        'bcc-notification',
        type ? `bcc-notification--${ type }` : 'bcc-notification--normal',
        customClass
      ]"
      :style="{top: verticalOffset + 'px'}"
      v-show="visible"
      role="alert">
      <div clsss="bcc-notification__contentArea" style="display:flex;">
        <bcc-icon :class="[ 'bcc-notification__tips', type ? `${ type }` : '' ]" :type="iconType" />
        <slot>
          <p v-if="!dangerouslyUseHTMLString" class="bcc-notification__content">{{ content }}</p>
          <p v-else v-html="content" class="bcc-notification__content"></p>
        </slot>
      </div>
      <bcc-icon v-if="!linkURL" class="bcc-notification__closeBtn" type="ic_delete_" @click="close" />
      <a v-else :href="linkURL" target="_blank" @click="close">查看详情</a>
    </div>
  </transition>
</template>

<script>
import BccIcon from '../icon'

export default {
  name: 'bccNotification',
  components: {
    BccIcon
  },
  data () {
    return {
      visible: false,
      content: '',
      type: 'normal',
      customClass: '',
      onClose: null,
      linkURL: '',
      showClose: false,
      closed: false,
      dangerouslyUseHTMLString: false,
      verticalOffset: 0,
      duration: 0,
      timer: null
    }
  },
  computed: {
    iconType () {
      switch (this.type) {
        case 'error' : return 'ic_Systemerror'
        case 'normal' : return 'ic_systemprompt'
        case 'success': return 'ic_successful'
        case 'warning': return 'ic_info-circle'
        default: return 'ic_systemprompt'
      }
    }
  },
  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false
      }
    }
  },
  methods: {
    handleAfterLeave () {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    },
    close () {
      this.closed = true
      if (this.timer) clearTimeout(this.timer)
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
    }
  },
  mounted () {
    if (this.duration) {
      this.timer = setTimeout(() => {
        this.timer = null
        this.close()
      }, this.duration)
    }
  }
}
</script>
